function showNav()
{
    var x = document.getElementById("mobile-nav");
    if (x.style.display === "none") {
        x.style.display = "block";
    } else {
        x.style.display = "none";
    }
}

function rotateMenu(menu)
{
    menu.classList.toggle("open");
}

function showProfile()
{
    var x = document.getElementById("mobile-profile");
    console.log(x);
    if (x.style.display === "none") {
        x.style.display = "block";
    } else {
        x.style.display = "none";
    }
}

// product detail - tabs
function openTab(evt, cityName)
{
    // Declare all variables
    var i, tabcontent, tablinks;

    // Get all elements with class="tabcontent" and hide them
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }

    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }

    // Show the current tab, and add an "active" class to the button that opened the tab
    document.getElementById(cityName).style.display = "block";
    evt.currentTarget.className += " active";
}


//modals
function fastOrder()
{


    /*var x = document.getElementById("fast-order");
    if (x.style.display === "none") {
      x.style.display = "block";
    } else {
      x.style.display = "none";
    }*/
}

function closeFastOrder()
{
    var x = document.getElementById("fast-order");
    if (x.style.display === "none") {
        x.style.display = "block";
    } else {
        x.style.display = "none";
    }
}

/*Dropdown Menu*/
$(document).on("click", ".dropdown-select", function () {
    $(this).attr("tabindex", 1).focus();
    $(this).toggleClass("active");
    $(this).find(".dropdown-menu").slideToggle(300);
});

$(document).on("focusout", ".dropdown-select", function () {
    $(this).removeClass("active");
    $(this).find(".dropdown-menu").slideUp(300);
});

$(document).on("click", ".dropdown-select .dropdown-menu li", function () {
    $(this).parents(".dropdown-select").find("span").text($(this).text());
    $(this)
    .parents(".dropdown-select")
    .find("input")
    .attr("value", $(this).attr("id")).trigger('click');
});

/*End Dropdown Menu*/

$(".dropdown-menu li").click(function () {
    var input =
            "<strong>" +
            $(this).parents(".dropdown-select").find("input").val() +
            "</strong>",
        msg = '<span class="msg">Hidden input value: ';
    $(".msg").html(msg + input + "</span>");
});

$(document).on('click', ".detail-photogallery-variants-more", function () {
    $(this).hide();
    $(document).find('.hidden-variants').slideToggle("slow", function () {

    });
});

jQuery.expr.filters.offscreen = function (el) {
    var rect = el.getBoundingClientRect();
    return (
        (rect.x + rect.width) < 0 || (rect.y + rect.height) < 0 || (rect.x > window.innerWidth || rect.y > window.innerHeight)
    );
};

$(document).on('click', '.show-add-to-basket', function () {

    let btn = $(this);
    let productId = btn.data('product-id');
    let dialogElement = $(document).find('#add-to-basket-' + productId);
    let dialogInstance = btn.data('dialog-instance');

    if (!dialogInstance) {
        dialogInstance = new BasicDialog(dialogElement.data('params'));
        dialogInstance.create();
        btn.data('dialog-instance', dialogInstance);
    }

    dialogInstance.open();

    let formData = {};
    formData.productId = productId;
    formData.prefillGroupColorId = btn.data("prefill-group-color");
    $.nette.ajax({
        url: $(this).data("href"),
        type: 'POST',
        data: formData,
        off: {
            snippets: true
        }
    });

});

$(document).on('click', '.show-add-to-offer', function () {

    let btn = $(this);
    let productId = btn.data('product-id');
    let dialogElement = $(document).find('#add-to-offer-' + productId);
    let dialogInstance = btn.data('dialog-instance');

    if (!dialogInstance) {
        dialogInstance = new BasicDialog(dialogElement.data('params'));
        dialogInstance.create();
        btn.data('dialog-instance', dialogInstance);
    }

    dialogInstance.open();

    let formData = {};

    formData.productId = $(this).data("product-id");
    formData.prefillGroupColorId = $(this).data("prefill-group-color");

    $.nette.ajax({
        url: $(this).data("href"),
        type: 'POST',
        data: formData,
        off: {
            snippets: true
        }

    });

});

$(document).ready(function () {
    let dialogElement = $(document).find('#notification-modal');
    if (dialogElement.length > 0) {
        dialogInstance = new BasicDialog(dialogElement.data('params'));
        dialogInstance.create();
        dialogInstance.open();
    }
});

$(document).on('click', '.show-modal-fast-order', function () {

    let btn = $(this);

    let dialogElem = btn.parent().find('.fast-order-modal-dialog');
    let dialogInstance = btn.data('dialog-instance');

    if (!dialogInstance) {
        dialogInstance = new BasicDialog(dialogElem.data('params'));
        dialogInstance.create();
        btn.data('dialog-instance', dialogInstance);
    }

    dialogInstance.open(function (dialog) {
        initSelect2ColorSize();
    });
});

$(document).on("submit", ".ajax-lock-form", function (e1) {
    e1.preventDefault();

    let form = $(this);
    let butt = form.find(".cta-add");
    if (butt.hasClass('disabled')) {
        return;
    }
    butt.addClass("disabled");
    form.find("#loader").show();

    let formData = new FormData(this);
    let formUrl = form.attr("action");

    $.nette.ajax({
        url: formUrl,
        data: formData,
        type: 'POST',
        processData: false,
        contentType: false,
        off: {
            snippets: true
        },
        success: function (payload) {
            if (payload.error) {
                toastr.warning(payload.error);
            }
            let butt2 = form.find(".cta-add");
            form.find("#loader").hide();
            butt2.removeClass('disabled');
            console.log(butt2);
        },
        error: function (err) {
            console.log('chyba');
            console.log(err);
        },
        complete: function () {
            let butt2 = form.find(".cta-add");
            form.find("#loader").hide();
            butt2.removeClass('disabled');
        }
    });
});

$(document).on('click', '.close-modal', function () {
    $(this).closest('.modal-container').hide();
    $(document).find('.overlay').hide();
});

$(document).on('change', '.sizeSelect, .colorSelect, .productAjaxSelect', function () {
    let form = $(this).closest('form');

    let size = form.find(".sizeSelect").val();
    let color = form.find(".colorSelect").val();

    if ($(this).hasClass('productAjaxSelect')) {
        // If change product -> reset size and color
        size = null;
        color = null;
    }

    $.nette.ajax({
        url: form.find(".initHandle").data('href'),
        type: 'POST',
        data: {
            product: form.find(".product").val(),
            size: size,
            color: color,
        },
        off: {
            snippets: true
        }
    });

});

$(document).on('click', '.show-modal-watch-dog', function () {
    let btn = $(this);
    let dialogElement = $(document).find('#watch-dog-modal');
    let dialogInstance = btn.data('dialog-instance');

    if (!dialogInstance) {
        dialogInstance = new BasicDialog(dialogElement.data('params'));
        dialogInstance.create();
        btn.data('dialog-instance', dialogInstance);
    }

    dialogInstance.open();
});

$(document).on('click', '.show-modal-print-offer', function () {

    let btn = $(this);
    let dialogElement = $(document).find('#modal-print-offer');
    let dialogInstance = btn.data('dialog-instance');

    if (!dialogInstance) {
        dialogInstance = new BasicDialog(dialogElement.data('params'));
        dialogInstance.create();
        btn.data('dialog-instance', dialogInstance);
    }

    dialogInstance.open();

});

function initSelect2ColorSize()
{

    let sizeSelect = $(document).find(".sizeSelect");
    if (sizeSelect) {
        sizeSelect.select2();
    }

    let colorSelect = $(document).find(".colorSelect");
    if (colorSelect) {
        colorSelect.select2({
            templateResult: formatColors,
            templateSelection: formatColors
        });
    }

    let productSelect = $(document).find(".productAjaxSelect");
    if (productSelect) {

        productSelect.select2({
            ajax: {
                delay: 500,
                url: productSelect.data('url'),
                data: function (params) {
                    return {
                        search: params.term
                    };
                },
                processResults: function (data) {

                    console.log(data);

                    // Transforms the top-level key of the response object from 'items' to 'results'
                    return {
                        results: data.items
                    };
                }
            }
        });
    }


}

function formatColors(opt)
{
    if (!opt.id) {
        return opt.text;
    }
    let res = opt.text.split("||");

    // style=" background-color: {$color->getHex()|noescape}"
    if (res[1] != '') {
        return $(
            '<div class="detail-color-box selectbox-color-box"><div class="circle">' +
            '<div style="background: linear-gradient(45deg, ' + res[0] + ' 50%, ' + res[1] + ' 50%)">' +
            '</div></div><div>' + res[2] + '</div></div>'
        );
    }

    return $(
        '<span class="dot-option"><span class="dot" style="background-color: ' + res[0] + '"></span> <span >' + res[2] + '</span></span>'
    );
}

$(document).on('click touch', '.plus.cnt-button', function (e) {

    console.log('plus');

    e.preventDefault();
    e.stopPropagation();

    let input = $(this).parent().find('input');
    input.val(parseInt(input.val()) + 1);
});

$(document).on('click touch', '.minus.cnt-button', function (e) {

    console.log('minus');

    e.preventDefault();
    e.stopPropagation();

    let input = $(this).parent().find('input');
    let val = parseInt(input.val()) - 1;
    if (val < 0) {
        return;
    }
    input.val(val);
});


$(document).on('click', '.show-more', function (e) {
    e.preventDefault();
    $(this).parent().find('.gradient').hide();
    $(this).parent().find('.detail-second-desc-text').addClass('full');
    $(this).hide();
});

$(document).on('click', '.close-modal, .overlay, .close-modal-btn', function () {
    $(document).find('.modal').hide();
    $(document).find('.modal-container').hide();
    $(document).find('.overlay').hide();
});

$(document).on('click', '.clicable-row', function (e) {
    if ($(e.target).hasClass('confirmLink')) {
        return;
    }
    window.location.href = $(this).data('href');
});

$(document).ready(function () {
    //setup before functions
    var autosubmitTimer;  //timer identifier
    var doneAutosubmitTypingInterval = 800;  //time in ms (5 seconds)

    //on keyup, start the countdown
    $('.autosubmit-form').keyup(function () {
        let form = $(this).closest('form');
        clearTimeout(autosubmitTimer);
        if ($('.autosubmit-form').val()) {
            autosubmitTimer = setTimeout(function () {
                form.find('.send-button').click();
            }, doneAutosubmitTypingInterval);
        }
    });

    //on keyup, start the countdown
    $('.autosubmit-form-check').change(function () {
        $(this).closest('form').find('.send-button').click();
    });

});


$(document).on('click', '.modal-track-open', function () {

    let btn = $(this);
    let dialogElement = $(document).find('#modal-track-info');
    let dialogInstance = btn.data('dialog-instance');

    if (!dialogInstance) {
        dialogInstance = new BasicDialog(dialogElement.data('params'));
        dialogInstance.create();
        btn.data('dialog-instance', dialogInstance);
    }
    dialogElement.find('.loader').show();

    dialogInstance.open();

    console.log('TUTUT');
    let formData = {};
    let handle = $(document).find("#modal-truck-handle");
    formData.subOrderId = $(this).data('id');

    $.nette.ajax({
        url: handle.data("href"),
        data: formData,
        type: 'POST',
        off: {
            snippets: true
        },
        success: function (payload) {
            dialogElement.find('.loader').hide();
        },
        error: function (err) {
            dialogElement.find('.loader').hide();
        }
    });
});


//setup before functions
var typingSearchTimer;         //timer identifier
var doneTypingSearchInterval = 300;  //time in ms (5 seconds)

function doneTypingSearch()
{
    let submit = $(document).find(".send-search-form");
    let searchBox = $(document).find(".search-box");
    submit.addClass('open');
    searchBox.addClass('open');

    $(document).find(".search-loader").show();
    $(document).find(".search-results").show();
    let formData = {};
    formData.search = searchBox.val();
    formData.category = $(document).find("#productCategorySearchHidden").val();

    $.nette.ajax({
        url: submit.data('presearch'),
        data: formData,
        type: 'POST',
        off: {
            snippets: true
        }
    }).done(function (data) {

    });
}

function closeSearchResults()
{
    let submit = $(document).find(".send-search-form");
    let searchBox = $(document).find(".search-box");
    submit.removeClass('open');
    searchBox.removeClass('open');
    $(document).find(".search-results").hide();
}

$(document).ready(function () {
    //on keyup, start the countdown
    $(document).find('.search-box').keyup(function () {
        clearTimeout(typingSearchTimer);
        if ($(document).find('.search-box').val()) {
            typingSearchTimer = setTimeout(doneTypingSearch, doneTypingSearchInterval);
        }
    });

    $(document).on('click', '.show-all', function () {
        $(document).find('.send-search-form').click();
    });

});

$(document).on('click', function (event) {
    var targetElement = $(event.target);
    if (!targetElement.closest('form.search').length) {
        closeSearchResults();
    }
});